// @flow

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';

import MapUI from './MapUI.jsx';

import {gen_snum} from './utils.js';

import type {T_MavDetail} from './types.js';

import './css/TableMav.css';


type T_TableMavProps = {
  mav_detail  : T_MavDetail,
  num_decimals: number,
  father      : MapUI
};



export default class TableMav extends Component<T_TableMavProps> {
  componentWillUnmount() {
    this.props.father.table_mav = null;
  }
  
  
  
  get_inner_html(): string {
    const el = ReactDOM.findDOMNode(this);
    
    if (el != null && el instanceof HTMLElement) {
      return el.innerHTML;
    }
    else {
      return '';
    }
  }
  
  
  
  render() {
    const snum = gen_snum(this.props.num_decimals);
    
    return (
      <table>
        <thead>
          <tr>
            <th>Desde</th>
            <th>Hasta</th>
            <th>Dosis (kg/ha)</th>
            <th>Área (has)</th>
            <th>Total (kg)</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {_.sortBy(this.props.mav_detail.rows, ['dosis']).map((row) => {
            return (
              <tr key={row.dosis}>
                <td>{snum(row.desde)}</td>
                <td>{snum(row.hasta)}</td>
                <td>{snum(row.dosis)}</td>
                <td>{snum(row.area )}</td>
                <td>{snum(row.total)}</td>
                <td style={{background: row.color}}>&nbsp;</td>
              </tr>
            );
          })}
        </tbody>
        <tfoot>
          <tr>
            <td />
            <td />
            <td />
            <td>{snum(_.sum(this.props.mav_detail.rows.map(row => row.area )))}</td>
            <td>{snum(_.sum(this.props.mav_detail.rows.map(row => row.total)))}</td>
            <td />
          </tr>
        </tfoot>
      </table>
    );
  }
}



// WEBPACK FOOTER //
// ./src/TableMav.jsx